<template>
    <div>
        <img style="height: 70px;" src="../../assets/images/masterCenter/topBg.jpg" alt="" class="banner-image">
        <div class="container" style="padding: 20px 50px">
            <section class="small-container">
                <h3 class="iconfont iconxiala">操作培训</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div>
                    <el-table
                        :header-cell-style="$root.tableHeaderStyle"
                        :cell-style="$root.tableCellStyle"
                        tooltip-effect="light"
                        size="mini"
                        :data="guides"
                        style="width: 100%">
                        <el-table-column
                            label="附件名称" style="width:70%">
                            <template slot-scope="scope">
                                <a href="javascript:void(0);" @click="fileDownload(scope.row.attachPath)" title="点击下载">{{ scope.row.attachName }}</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'guides',
    data() {
        return {
            guides: [
                {
                    attachName: '供应商发起质疑.zip',
                    attachPath: '/static/helps/%E4%BE%9B%E5%BA%94%E5%95%86%E5%8F%91%E8%B5%B7%E8%B4%A8%E7%96%91.zip'
                }, {
                    attachName: '供应商回标.zip',
                    attachPath: '/static/helps/%E4%BE%9B%E5%BA%94%E5%95%86%E5%9B%9E%E6%A0%87.zip'
                }, {
                    attachName: '供应商注册.zip',
                    attachPath: '/static/helps/%E4%BE%9B%E5%BA%94%E5%95%86%E6%B3%A8%E5%86%8C.zip'
                }, {
                    attachName: '智慧招采平台培训-供应商外网.pdf',
                    attachPath: '/static/helps/%E6%99%BA%E6%85%A7%E6%8B%9B%E9%87%87%E5%B9%B3%E5%8F%B0%E5%9F%B9%E8%AE%AD-%E4%BE%9B%E5%BA%94%E5%95%86%E5%A4%96%E7%BD%91.pdf'
                }
            ],
        }
    },
//方法集合
    methods: {
        fileDownload(attachPath) {
            let msg = '确定下载该附件吗?';
            if (attachPath.endsWith('mp4')){
                msg = '确定播放该视频文件吗?';
            }
            if(attachPath.endsWith('pdf')) {
                window.open(attachPath);
            } else {
                this.$confirm(msg, {
                    type: 'warning',
                    callback: (action) => {
                        if (action == 'confirm') {
                            window.open(attachPath);
                        }
                    }
                });
            }

        },
    }
}
</script>
<style lang="scss">
@import '../../assets/_var.scss';

#listDetail {
    background-color: $--primary-fill-color;

    & .head-top {
        background: #fff;
    }

    & .head-right {
        color: $--text-color-light;

        & .login {
            background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }

        & .register {
            // background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }

        & .line {
            background: $--text-color-light;
        }

        & .help {
            background: url('../../assets/images/topBar2/icon05.png') no-repeat;
        }

        & .wechat {
            background: url('../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }

    & .mainCon {
        margin-top: 15px;
        padding-bottom: 50px;
    }

    .location {
        padding-left: 15px;
        text-align: left;
        font-size: 12px;
        line-height: 42px;
        color: $--text-color-light;
        background: url('../../assets/images/inviteList/location.png') no-repeat left center;
    }

    .detailCon {
        padding: 70px 70px 90px;
        background: #fff;

        .detailList {
            /*margin-top: 20px;*/
            h3 {
                margin-top: 30px;
                padding-left: 75px;
                padding-top: 23px;
                text-align: left;
                font-size: 16px;
                line-height: 26px;
                background: url('../../assets/images/invitemanage/titbg01.png') no-repeat;
            }

            h3:nth-of-type(2) {
                background: url('../../assets/images/invitemanage/titbg02.png') no-repeat;
            }

            h3:nth-of-type(3) {
                background: url('../../assets/images/invitemanage/titbg03.png') no-repeat;
            }

            .firstList {
                margin-top: 30px;
                padding: 0 65px;

                li {
                    text-align: left;
                    /*margin-top: 20px;*/
                    font-size: 14px;
                    line-height: 48px;

                    em {
                        color: $--text-color-lighter;
                        font-style: normal;
                        padding-left: 25px;
                        background: url('../../assets/images/invitemanage/listIcon.png') no-repeat;
                    }

                    span {
                        color: $--text-color-light;
                    }
                }
            }

            p {
                margin-top: 25px;
                padding: 0 65px;
                text-align: left;
                font-size: 14px;
                line-height: 34px;
                color: $--text-color-light;
            }

            .email {
                span {
                    display: inline-block;
                    margin-right: 5px;
                    width: 32px;
                    height: 32px;
                    vertical-align: middle;
                    background: url('../../assets/images/invitemanage/icon06.png') no-repeat;
                }

                strong {
                    color: $--text-color;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/guideFile.vue